// Footer
export const CONF_POLICY = 'Политика конфиденциальности';
export const TOUR_HUNTER = 'TourHunter';
